import axios from 'axios'
import { Toast } from 'vant'
// import router from '@/router'
// import util from './util'
// import storage from "@/utils/storage"
import store from '@/store';
// import md5 from "js-md5"
// create an axios instance
const urlPath = '/';
const service = axios.create({
  baseURL: urlPath, // api的base_url
  timeout: 300000, // request timeout
  withCredentials: true, //让ajax携带cookie
})
// request interceptor
// 添加请求拦截器
service.interceptors.request.use(config => {
  store.commit('showLoading')
  // Do something before request is sent
  config.headers['Cache-Control'] = 'no-cache' // ie清缓存，否则无法正常刷新
  config.headers['Pragma'] = 'no-cache' // HTTP/1.1版本，ie清缓存，否则无法正常刷新
  // config.headers['token'] = storage.get('token') || ''
  if (config.formType && config.formType === 1) {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    if(config.config) {
      config.headers['Content-Type'] = config.config.ContentType;
    }
    config.transformRequest = [function (data) {
      // Do whatever you want to transform the data
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret.substring(0, ret.length - 1)
    }]
  }
  return config
}, error => {
  store.commit('hideLoading')
  // Do something with request error
  Promise.reject(error)
})

// respone interceptor
// 添加响应拦截器
service.interceptors.response.use(
  response => {
    store.commit('hideLoading')
    var res = response.data
    // 以下请根据后端返回具体格式修改!!!!!
    if (res.code == 200) {
      return res
    } else {
      Toast(res.msg||'请求失败');
      return Promise.reject(res)
    }
  },
  error => {
    // 错误处理
    store.commit('hideLoading')
    Toast(error.message);
    return Promise.reject(error)
  }
)



export default service